export default __webpack_public_path__ + "static/media/nextDate.ad4d6f81.svg";